import React from 'react';

// import { Container } from './styles';
interface VimeoProps {
  id: string;
  keyName?: string;
  time?: string;
  allow?: string;
}

const IframePlayer: React.FC<VimeoProps> = ({ allow = "fullscreen", id = '', keyName, time = '0' }) => {
  return (
    <div
      className="video"
      style={{
        position: 'relative',
        paddingBottom: '56.25%' /* 16:9 */,

        height: 0,
        width: '100%',
      }}
    >
      <iframe
        key={keyName || `videoPlay${new Date().getTime()}`}
        frameBorder="0"
        allow={allow}
        allowFullScreen

        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
        title={id}
        src={`${id}?title=0&byline=0&portrait=0${time ? `/#t=${time}` : ''}`}
      />
    </div>
  );
};

export default IframePlayer;
